export const BING_INPUT_CHARACTER_LIMIT = 2500;
export const BING_RESPONSE_CHARACTER_LIMIT = 10000;
